import React from 'react';
import { AnalyzerSection } from './components/AnalyzerSection';
import { HotelAnalyzerConfig } from './types';

interface WidgetAppProps {
  config: HotelAnalyzerConfig;
}

const WidgetApp: React.FC<WidgetAppProps> = ({ config }) => {
  return (
    <div className="ha-widget-root ha-font-sans ha-antialiased ha-bg-background ha-text-foreground">
      <AnalyzerSection />
    </div>
  );
};

export default WidgetApp;
